<script>
import WorkoutList from '@components/workout/workout-list.vue';
import WorkoutPreview from '@components/workout/workout-preview.vue';
import { adminPanelComputed } from '@state/helpers';

export default {
  components: {
    WorkoutList,
    WorkoutPreview,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...adminPanelComputed,
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div class="split-pane">
    <div class="pane-left">
      <WorkoutList
        :content="panelContent"
        :showWorkoutFilters="true"
        :hideDescription="true"
      >
        <slot slot="toWorkoutList">
          <slot name="toSplitPane" />
        </slot>
      </WorkoutList>
    </div>
    <div class="pane-right">
      <WorkoutPreview
        v-if="panelContent && panelContent.data && panelContent.data.details"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.split-pane {
  display: flex;
  overflow-y: hidden;

  .pane-left,
  .pane-right {
    flex: 1;
    height: 100vh;
    overflow-y: scroll;
    padding-bottom: 10rem;
    position: fixed;
    width: 50%;
  }

  .pane-left {
    border-right: 2px solid $color-light-gray;
    right: 50%;
  }

  .pane-right {
    left: 50%;
    padding-bottom: unset;
  }
  // stylelint-disable selector-pseudo-element-no-unknown
  ::v-deep .panel-footer {
    bottom: 10rem !important;
  }
  ::v-deep {
    .exercise-filters,
    .workout-filters {
      padding: 2rem 2rem 0;

      .search-input-wrapper {
        width: 100%;
      }

      .col-3 {
        -webkit-box-flex: 0;
        flex: 0 0 50%;
        max-width: 50%;
      }
    }

    .exercise-item {
      padding-left: 2rem;
    }

    .exercise-title h3 {
      font-size: 1.8rem;
    }
  }
}
</style>
